export default __webpack_public_path__ + "static/cloud-0-387378bb0f11c1d9396bc56e697a7264.png";